
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import AttestationDef from '@/extend/classes/AttestationDef';
import { storeSession } from '@/generated/stores';
import HubServices from "@/generated/hub/HubServices";
import ListData, { ListItem, ColumnConfig, ListConfig, ListFilter } from '@/extend/classes/ListData';
import { Alerts } from '@/framework/base/helpers/Alerts';

import { v4 as uuidv4 } from 'uuid';


@Module({ name: 'storeAttestationDef' })

export default class storeAttestationDef extends VuexModule {
  // States
  private reccords: AttestationDef[] = [];
  private config : ColumnConfig[] = [];
  private idsLoading: number[] = [];
  private dataLoading = false;
  private dataLoaded = false;
  private dataRegistered = false;

  // Getters on states for asynchronous actions
  private get attestationDefLoading (): boolean {
    return this.dataLoading;
  }
  private get attestationDefRegistered (): boolean {
    return this.dataRegistered;
  }

  
  public get attestationDefLoaded (): boolean {
    return this.dataLoaded;
  }

  public get createNewAttestationDef() {
    return (): AttestationDef => { 
      return this.getAttestationDef(0, true);
    }
  }

  
  public get getAttestationDef () {
    return (id: number, canCreate = false): AttestationDef => {
      if (id == 0 && !canCreate) {
        Alerts.debug("Id AttestationDef can't be 0")
        return new AttestationDef();
      }
      const res = this.reccords.find(c => c.id == id);
      if (res != undefined) {
        return res;
      } else {
        const copy = new AttestationDef();
        if (id == 0) {
          if (this.reccords.length == 0) {
            copy.id = -1;
          } else {
            this.reccords.sort((a, b) => (a.id - b.id));
            copy.id = Math.min(-1, this.reccords[0].id - 1);
          }          copy.canDelete = true;          copy.canUpdate = true;
          copy.createId = uuidv4();
          this.reccords.push(copy);
        } else if (id > 0) {
          copy.id = id;
          this.reccords.push(copy);
          if (storeSession.httpCx != undefined && !this.idsLoading.includes(id)) {
            this.idsLoading.push(id);
            AttestationDef.getForStore(id).then((data: ListData) => {
              const tmpCopy = this.reccords.find(a => a.id == id);
              if (tmpCopy) {
                tmpCopy.fromAttestationDef(data.reccords[0] as AttestationDef);
              }
              const config = data.config as ListConfig
              if (this.config.length == 0) {
                config.columnsConfig.forEach((column) => {
                  this.config.push(column);
                })
              } else {
                config.columnsConfig.forEach((column) => {
                  if (column.choix.length == 1) {
                    const columnConfig = this.config.find(a => a.name == column.name);
                    if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
                      const columnChoix = columnConfig.choix;
                      const newChoix = column.choix[0];
                      columnChoix.push(newChoix);
                    }
                  }
                });
              }
              const index = this.idsLoading.findIndex(x => x == id);
              if (index >= 0) {
                this.idsLoading.splice(index, 1);
              }
            })
          }
        }
        return copy
      }
    }
  }


  

  public get listAttestationDef (): AttestationDef[] {
    return this.reccords;
  }

  public get listConfigAttestationDef (): ColumnConfig[] {
    return this.config;
  }


  @Mutation
  private mAttestationDefRegistered (): void {
    this.dataRegistered = true;
  }

  @Mutation
  public mAttestationDefClearData (): void {
    this.reccords = [];
    this.idsLoading = [];
    this.dataLoading = false;
    this.dataLoaded = false;
    this.dataRegistered = false;
  }

  @Mutation
  private mAttestationDefLoading (value: boolean): void {
    this.dataLoading = value;
  }

  @Mutation
  private mAttestationDefLoaded (data: ListData): void {
    this.dataLoaded = true;
    this.idsLoading.splice(0, this.idsLoading.length);
    this.reccords = [];
    data.reccords.forEach((reccord) => {
      this.reccords.push(AttestationDef.fromJson(reccord as AttestationDef));
    })
    AttestationDef.getDate(this.reccords);
    this.config = data.config.columnsConfig;
  }

  @Mutation
  private mAttestationDefConfigUpdated (newConfig: ListConfig): void {
    newConfig.columnsConfig.forEach((column) => {
      if (column.choix.length == 1) {
        const columnConfig = this.config.find(a => a.name == column.name);
        if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
          const columnChoix = columnConfig.choix;
          const newChoix = column.choix[0];
          columnChoix.push(newChoix);
          console.log(newChoix);
        }
      }
    });
  }

  @Mutation
  public mAttestationDefCreated (obj: AttestationDef): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      let api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareAttestationDef(obj)) {
          api.fromAttestationDef(obj);
        }
      } else {
        api = this.reccords.find(x => x.createId == obj.createId && obj.createId != null && obj.createId != '');
        if (api) {
          if (!api.compareAttestationDef(obj)) {
            api.fromAttestationDef(obj);
          } else if (api.id != obj.id ) {
            api.id = obj.id;
          }
        } else {
          this.reccords.push(obj);
        }
      }
    }
  }

  @Mutation
  public mAttestationDefUpdated (obj: AttestationDef): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      const api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareAttestationDef(obj)) {
          api.fromAttestationDef(obj);
        }
      } else {
        this.reccords.push(obj);
      }
    }
  }

  @Mutation
  public mAttestationDefDeleted (id: number): void {
    const index = this.reccords.findIndex(x => x.id == id);
    if (index >= 0) {
      this.reccords.splice(index, 1);
    }
  }

    
  @Action
  public registerAttestationDef (filter: ListFilter | null = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.attestationDefRegistered && storeSession.hubUsed) {
        if (HubServices.hubReady()) {
          HubServices.registerAttestationDef(this.attestationDefCreated, this.attestationDefUpdated, this.attestationDefDeleted);
          this.mAttestationDefRegistered();
        } else {
          setTimeout(() => resolve(this.registerAttestationDef(filter)), 1000);
        }
      }
      if (filter != null) {
        if (HubServices.hubReady() && !this.attestationDefLoading && !this.attestationDefLoaded) {
          this.mAttestationDefLoading(true);
          return AttestationDef.list(filter)
            .then((data: ListData) => {
              this.mAttestationDefLoaded(data);
              this.mAttestationDefLoading(false);
              resolve(true);
            })
        }
      } else  {
        resolve(true);
      }
  })
}


  @Action
  public listFilteredAttestationDef (filter: ListFilter): Promise<boolean> {
    return new Promise((resolve) => {
      if (HubServices.hubReady() && !this.attestationDefLoading) {
        this.mAttestationDefLoading(true);
        return AttestationDef.list(filter)
          .then((data: ListData) => {
            this.mAttestationDefLoaded(data);
            this.mAttestationDefLoading(false);
            resolve(true);
          })
      }
    })
  }


  
  @Action
  public createAttestationDef (obj: AttestationDef): Promise<AttestationDef> {
    return new Promise((resolve, reject) => {
      return AttestationDef.fromJson(obj).createForStoreAttestationDef()
        .then((reccords) => {
          this.mAttestationDefCreated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  public updateAttestationDef (obj: AttestationDef): Promise<AttestationDef> {
    return new Promise((resolve, reject) => {
      return AttestationDef.fromJson(obj).updateForStoreAttestationDef()
        .then((reccords) => {
          this.mAttestationDefUpdated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }
  
  @Action
  public deleteAttestationDef (obj: AttestationDef): Promise<boolean> {
    return new Promise((resolve, reject) => {
      return AttestationDef.fromJson(obj).deleteForStoreAttestationDef()
        .then(() => {
          if (!storeSession.hubUsed) {
            this.mAttestationDefDeleted(obj.id);
          }
          resolve(true);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  private attestationDefCreated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mAttestationDefConfigUpdated(config)
    const obj = objConfig.obj as AttestationDef;
    this.mAttestationDefCreated(AttestationDef.fromJson(obj));
  }

  @Action
  private attestationDefUpdated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mAttestationDefConfigUpdated(config)
    const obj = objConfig.obj as AttestationDef;
    this.mAttestationDefUpdated(AttestationDef.fromJson(obj));
  }

  @Action
  private attestationDefDeleted (objConfig: ListItem): void {
    const obj = objConfig.obj as AttestationDef;
    this.mAttestationDefDeleted(obj.id);
  }
}
